import { createContext } from "react";

/**
 * True while the open document's links are still loading.
 *
 * Anchors read it at render time instead of receiving it at parse time, so the
 * end of loading re-renders the few anchors rather than re-parsing the whole
 * document through html-react-parser (LAR-487).
 */
export const DocumentLinksLoadingContext = createContext(false);
